<div class="accordion">
	<div class="accordion-header">
		<h6 class="accordion-title">{{ title }}</h6>
		<a class="toggle-accordion" (click)="visible= !visible">
			<nb-icon icon="{{visible ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'}}"></nb-icon>
		</a>
	</div>

	@if (visible) {
		<ng-content></ng-content>
	}
</div>
